import GenericLoader from "../../Framework/Components/Loaders/GenericLoader";
import {useEffect} from "react";
import {useUKPBAuth} from "../../Providers/AuthProvider";

const OAuthRedirect = () => {
    const { token, loginInProgress, loggingOut, RedirectError, LogInSuccess } = useUKPBAuth();

    useEffect(() => {
        if(!loggingOut.current && !loginInProgress && token === '') {
            RedirectError();
        } else if(token && !loginInProgress) {
            LogInSuccess();
        }
    }, [token, loginInProgress ]);

    return (
        <div className={'fill-container'}>
            <GenericLoader />
        </div>
    )
}

export default OAuthRedirect
